var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"exchange-rate"},[(_vm.conversionRateInfo)?_c('div',{staticClass:"exchange-rate__info"},[_vm._v(" "+_vm._s(_vm.conversionRateInfo)+" ")]):_c('loading-spinner',{attrs:{"radius":0.8,"color":"#9b9b9b"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }